module.exports = __webpack_public_path__ + "static/media/white-identify-multiple-features-icon.36a8a6df.svg";